import * as types from './association.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	get: payload => ({
		type: types.GET_ASSOCIATION,
		payload,
	}),
	set: payload => ({
		type: types.SET_ASSOCIATION,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_ASSOCIATION,
		payload,
	}),
	remove: payload => ({
		type: types.DELETE_ASSOCIATION,
		payload,
	}),
	getStaticOptions: payload => ({
		type: types.GET_STATIC_OPTIONS,
		payload,
	}),
	getDynamicOptions: payload => ({
		type: types.GET_DYNAMIC_OPTIONS,
		payload,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
